import { render, staticRenderFns } from "./FactsView.vue?vue&type=template&id=7a36b100&scoped=true&"
import script from "./FactsView.vue?vue&type=script&lang=js&"
export * from "./FactsView.vue?vue&type=script&lang=js&"
import style0 from "./FactsView.vue?vue&type=style&index=0&id=7a36b100&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36b100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
